module.exports = __webpack_public_path__ + "static/media/fps.9feb0fe8.png";